<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { Modal } from "bootstrap";
import creditCashAccounts from "../../../../components/creditCashAccounts.vue";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    creditCashAccounts,
  },
  data() {
    return {
      HrApproveAward: [],
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchHrApproveAward: null,
      HrApproveAwardSearchMode: false,
      searchModel: "",
      pay_award_modal: {},
      add_reward_modal: {},
      hr_award: {},
      hr_employees: [],
      hr_award_types: [],
      cash_accounts: [],
      currency: {},
    };
  },
  methods: {
    search(page) {
      if (this.searchModel.length == 0) return this.cancelappsearchMode();

      this.HrComplainsSearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("hr-awards/search", {
          search: this.searchModel,
          limit: this.limit,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.HrApproveAward = res.data;
        });
    },
    cancelappsearchMode() {
      this.searchModel = "";
      this.HrApproveAwardSearchMode = false;
      this.get(this.page);
    },

    // getHrApproveAward() {
    //   this.http.get("hr-awards/get-manager-approve").then((res) => {
    //     this.HrApproveAward = res.data;
    //   });
    // },
    hrEmployeeSearch(search) {
      this.http
        .post("emps/employees-search", {
          search,
          page: 1,
          limit: 20,
          col: "name",
        })
        .then((res) => {
          this.hr_employees = res.data;
        });
    },
    showHrEmployeeLabel(one) {
      return one.name;
    },
    openAddHrAwards() {
      this.add_reward_modal.show();
    },
    addHrAward() {
      console.log("step 69 :", this.hr_award);
      this.http
        .post("hr-awards", {
          hr_employee_id: this.hr_award?.hr_employee?.id,
          hr_award_type_id: this.hr_award?.hr_award_type_id,
          descr: this.hr_award?.descr,
          total_amount: this.hr_award?.total_amount,
          month: this.hr_award?.month.split("-")[1],
          year: this.hr_award?.month.split("-")[0],
        })
        .then((res) => {
          if (res.status) {
            this.add_reward_modal.hide();
            this.get(1);
            this.getHrAwardTypes();
            this.hr_award = {};
          }
        });
    },
    get(page) {
      this.http
        .post("hr-awards/paginate", {
          limit: this.limit,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.HrApproveAward = res.data;
        });
    },

    approve(app) {
      var data = {
        title: "popups.approve",
        msg: "popups.approve_msg",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          console.log("###");
          this.http.post("hr-awards/approve/" + app.id, {}).then(() => {
            //  this.getHrApproveAward();
            this.get(1);
          });
        }
      });
    },

    reject(app) {
      var data = {
        title: "popups.reject",
        msg: "popups.reject_msg",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          console.log("###");
          this.http
            .put("hr-awards", app.id, {
              general_manager_approve: 0,
            })
            .then(() => {
              this.get(this.page);
            });
        }
      });
    },
    getHrAwardTypes() {
      this.http.get("hr-award-types").then((res) => {
        this.hr_award_types = res.data;
      });
    },
    openPayModal(record) {
      this.hr_award = record;
      console.log("step 142 :", this.hr_award);
      this.pay_award_modal.show();
    },
    getCashAccounts() {
      this.http.get("hr-awards/purchase/configurations").then((res) => {
        this.cash_accounts = res.data;
        console.log("caaaash", this.cash_accounts);
      });
    },
    getSDGCurrency(id) {
      this.http.get("currencies/" + id).then((res) => {
        this.currency = res.data;
      });
    },
    payAward() {
      console.log("aaa", this.hr_award, typeof this.hr_award.accounts);
      const total_cash = this.hr_award?.accounts.reduce((total, account) => {
        return (total += account.value ? parseFloat(account.value) : 0);
      }, 0);
      console.log("total", total_cash, this.hr_award?.accounts);
      if (parseFloat(this.hr_award.total_amount) != total_cash) {
        return this.popup.alert({
          title: this.$t("popups.error"),
          msg: this.$t("popups.cash_no_equal_total_amount"),
        });
      } else {
        this.http
          .post("hr-awards/pay-award", {
            id: this.hr_award?.id,
            accounts: this.hr_award?.accounts,
          })
          .then((res) => {
            if (res.status) {
              this.pay_award_modal.hide();
              this.hr_award = {};
              this.getSDGCurrency(1);
              this.getCashAccounts();
              this.get(1);
              this.getHrAwardTypes();
            }
          });
      }
    },
  },

  created() {
    this.getSDGCurrency(1);
    this.getCashAccounts();
    this.get(1);
    this.getHrAwardTypes();
  },
  mounted() {
    this.pay_award_modal = new Modal("#pay-award-modal");
    this.add_reward_modal = new Modal("#addModal");
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('hr_awards.title')"
    />

    <div class="row">
      <div class="col-6 mb-4">
        <div class="search-box chat-search-box w-50">
          <div class="position-relative">
            <input
              @input="search(page)"
              type="search"
              class="form-control fa-lg text-light"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              :placeholder="$t('popups.search')"
              v-model="searchModel"
              style="background-color: #2a3042 !important"
            />
            <i class="bx bx-search-alt search-icon text-light"></i>
          </div>
        </div>
      </div>
      <div class="col-6" style="display: flex; justify-content: flex-end">
        <button
          type="button"
          @click="openAddHrAwards()"
          class="btn btn-light float-end mb-4"
        >
          <span
            class="bx bxs-plus-circle float-end fa-2x"
            style="color: #2a3042 !important"
          ></span>
        </button>
      </div>
    </div>
    <div class="table-responsive">
      <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
        <thead>
          <tr
            class="text-light text-center"
            style="background-color: #2a3042 !important"
          >
            <th scope="col">{{ $t("hr_awards.id") }}</th>
            <th scope="col">{{ $t("hr_awards.employee") }}</th>
            <th scope="col">{{ $t("hr_awards.award_type") }}</th>
            <th scope="col">{{ $t("hr_awards.descr") }}</th>
            <th scope="col">{{ $t("hr_awards.total_amount") }}</th>
            <th scope="col">{{ $t("hr_awards.paid_amount") }}</th>
            <th scope="col">{{ $t("hr_awards.month") }}</th>
            <th scope="col">{{ $t("hr_awards.year") }}</th>
            <th scope="col">{{ $t("hr_awards.date") }}</th>
            <th scope="col">{{ $t("hr_awards.operations") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(app, index) in HrApproveAward"
            :key="app"
            class="text-center"
          >
            <td>{{ (page - 1) * this.limit + index + 1 }}</td>
            <td>{{ app?.hr_employee?.name }}</td>
            <td>{{ app?.hr_award_type?.name }}</td>
            <td>{{ app?.descr }}</td>
            <td>{{ app?.total_amount }}</td>
            <td>{{ app?.paid_amount }}</td>
            <td>{{ app?.month }}</td>
            <td>{{ app?.year }}</td>
            <td>{{ app?.created?.split("T")[0] }}</td>

            <td>
              <a
                class="btn btn-primary mx-1"
                :class="{ 'd-none': app.general_manager_approve }"
                @click="approve(app)"
                href="javascript: void(0);"
                role="button"
                >{{ $t("popups.approve") }}</a
              >
              <a
                class="btn btn-success mx-1"
                v-if="app.general_manager_approve && app.paid_amount == 0"
                @click="openPayModal(app)"
                href="javascript: void(0);"
                role="button"
                >{{ $t("popups.pay_award") }}</a
              >

              <div
                v-if="
                  app.general_manager_approve &&
                  app.total_amount == app.paid_amount
                "
              >
                <span class="badge-soft-success badge badge-pill font-size-11">
                  {{ $t("hr_awards.paid") }}
                </span>
              </div>

              <!-- <a
                v-if="app.paid_amount ==0"
                class="btn btn-danger"
                href="javascript: void(0);"
                role="button"
                @click="reject(app)"
                >{{ $t("popups.reject") }}</a
              >  -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- end  table -->
    <!-- Button trigger modal -->

    <div>
      <!--   Apps  Pagination     -->
      <ul class="pagination pagination-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="searchModel ? search(page - 1) : get(page - 1)"
            aria-label="Previous"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          :class="{ active: p == page }"
          v-for="p in tot_pages"
          :key="p"
        >
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="searchModel ? search(p) : get(p)"
            >{{ p }}</a
          >
        </li>

        <li class="page-item" :class="{ disabled: page == tot_pages }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="searchModel ? search(page + 1) : get(page + 1)"
            aria-label="Next"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>

    <!--Pay Modal -->
    <div
      class="modal fade"
      id="pay-award-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <form @submit.prevent="payAward()">
            <div class="modal-header">
              <h5 class="modal-title">
                {{ $t("popups.pay_award") }}
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style="margin: 0; right: auto"
              ></button>
            </div>
            <div class="modal-body">
              <div class="form-group mb3">
                <label for="">{{ $t("hr_awards.total_amount") }}</label>
                <input
                  type="number"
                  required
                  disabled
                  :value="hr_award.total_amount"
                  class="form-control"
                />
              </div>
              <div class="form-group mb-3">
                <creditCashAccounts
                  v-model="hr_award.accounts"
                  v-if="cash_accounts && cash_accounts.length > 0"
                  :cashAccounts="this.cash_accounts[0]"
                />
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                @click="pay_award_modal.hide()"
                class="btn btn-danger"
              >
                {{ $t("popups.cancel") }}
              </button>
              <button type="submit" class="btn btn-primary">
                {{ $t("popups.pay") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Add Hr Reward Modal -->
    <div
      class="modal fade"
      id="addModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <form @submit.prevent="addHrAward()">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t("popups.add") }}</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style="margin: 0; right: auto"
              ></button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <label for="" class="form-label">{{
                  $t("hr_awards.employee")
                }}</label>
                <AutoComplete
                  v-model="hr_award.hr_employee"
                  :suggestions="hr_employees"
                  :loading="true"
                  @complete="hrEmployeeSearch($event.query)"
                  :complete-on-focus="true"
                  :optionLabel="showHrEmployeeLabel"
                  :input-class="'form-control'"
                  style="color: #333 !important; width: 100%"
                />
              </div>

              <div class="form-group mb-3">
                <label for="">{{ $t("hr_awards.award_type") }}</label>
                <select
                  required
                  v-model="hr_award.hr_award_type_id"
                  class="form-select"
                  name=""
                  id=""
                >
                  <option
                    v-for="(type, index) in hr_award_types"
                    :key="index"
                    :value="type.id"
                  >
                    {{ $i18n.locale == "en" ? type.name_en : type.name }}
                  </option>
                </select>
              </div>
              <div class="form-group mb-3">
                <label for="">{{ $t("hr_awards.descr") }}</label>

                <textarea
                  v-model="hr_award.descr"
                  class="form-control"
                  name=""
                  id=""
                  rows="3"
                ></textarea>
              </div>
              <div class="form-group mb-3">
                <label for="">{{ $t("hr_awards.total_amount") }}</label>

                <currencyInput
                  required
                  v-model="hr_award.total_amount"
                  class="form-control"
                />
              </div>
              <div class="form-group mb-3">
                <label for="">{{ $t("hr_awards.month") }}</label>

                <input
                  required
                  type="month"
                  v-model="hr_award.month"
                  class="form-control"
                />
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
                @click="add_reward_modal.hide()"
              >
                {{ $t("popups.cancel") }}
              </button>
              <button type="submit" class="btn btn-primary">
                {{ $t("popups.add") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--end-->
  </Layout>
</template>

<style scoped>
.btn-close {
  position: relative;
  right: 317px;
  top: 6px;
  font-size: 15px;
}
</style>
